// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://upqcbndtdbuxllzixikm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVwcWNibmR0ZGJ1eGxseml4aWttIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDExOTEyMjUsImV4cCI6MjA1Njc2NzIyNX0.R4JimJ4nk3apfYs-NOWaDs8qjzElLNsP3QUoOimjQZY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);